<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp
      :style="`--v-global-theme-primary: ${hexToRgb(
        global.current.value.colors.primary
      )}`"
    >
      <RouterView />

      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
<script setup>
import useHttpRequest from "@/composables/useHttpRequest";
import useUserStore from "@/store/useUserStore";
import ScrollToTop from "@core/components/ScrollToTop.vue";
import initCore from "@core/initCore";
import { initConfigStore, useConfigStore } from "@core/stores/config";
import { hexToRgb } from "@core/utils/colorConverter";
import { useTheme } from "vuetify";
import { requestNotificationPermission } from './firebase';

const { global } = useTheme();

// ℹ️ Sync current theme with initial loader theme
initCore();
initConfigStore();

const configStore = useConfigStore();

let lastActivityTime = Date.now();
const { get, post } = useHttpRequest();
const userStore = useUserStore();

// Track user activity
const updateActivity = () => (lastActivityTime = Date.now());

window.addEventListener("mousemove", updateActivity);
window.addEventListener("keydown", updateActivity);

// Refresh interval: Every 30 minutes
setInterval(() => {
  const now = Date.now();
  const inactiveTime = now - lastActivityTime;

  if (inactiveTime <= 25 * 60 * 1000 && userStore.authUser != null && userStore.authUser?.is_remember == false) {
    // User was active in last 25 mins & user is logged in → refresh token
    refreshToken();
  }
}, 30 * 60 * 1000); // 30 min
// 30 sec - 30 * 1000
// 25 sec - 25 * 1000
// 30 min - 30 * 60 * 1000
// 25 min - 25 * 60 * 1000
const refreshToken = async () => {
  const { status, data } = await get("/update-token");

  if (status != 200) {
    console.error("Failed to refresh token", data.message);
  }
};

const fetchPermissions = async () => {
  const { get } = useHttpRequest();
  const res = await get("/user/permissions");
  if (res.status === 200) {
    userStore.setPermissions(res.data.permissions);
  }

  return true;
}

const saveTokenToServer = async (token) => {
  let values = {
    token: token
  };
  const res = await post('/fcm/save-token', values);
};

watch(() => userStore.authUser, (user) => {
  if (user) {
    fetchPermissions();
  }

  if (user && user.set_device_token == false) {
    requestNotificationPermission().then(token => {
      if (token) {
        saveTokenToServer(token);
      }
    });    
  }
}, { immediate: true });

</script>
